import React, { useEffect, useState } from 'react';

import DigitInput from '@/widgets/OtpInputs/_components/DigitInput';
import { otpInputsProps } from '@/widgets/OtpInputs/models';

import { useOTP } from '@/hooks/auth/useOtp';

export const OtpInputs = ({ onSubmit, inputsLength = 5 }: otpInputsProps) => {
    const [digits, setDigits] = useState<string[]>(Array(inputsLength).fill(''));
    const { otpCode, startOTP } = useOTP();

    useEffect(() => {
        if (otpCode) {
            setDigits(otpCode.split(''));
        }
    }, [otpCode]);

    useEffect(() => {
        setTimeout(() => {
            startOTP();
        }, 100);
        document.getElementById('digit-0')?.focus();
    }, []);

    useEffect(() => {
        if (digits.length === inputsLength) {
            const code = digits.join('');
            onSubmit(code);
        }
    }, [digits]);

    const handleInputChange = (index: number, value: string) => {
        const newDigits = [...digits];
        newDigits[index] = value;
        setDigits(newDigits);

        if (value.length === 1 && index < inputsLength - 1) {
            const nextInput = document.querySelector(`#digit-${index + 1}`) as HTMLInputElement;
            nextInput.focus();
        }

        const code = newDigits.join('');
        if (code.length === inputsLength) {
            onSubmit(code);
        } else if (code.length === 0) {
            onSubmit('');
        }
    };

    const handleDelete = (index: number) => {
        const newDigits = [...digits];
        newDigits[index] = '';
        setDigits(newDigits);

        if (index > 0 && digits[index - 1] !== '') {
            const prevInput = document.querySelector(`#digit-${index - 1}`) as HTMLInputElement;
            prevInput.focus();
        }
    };

    const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
        event.preventDefault();
        const pastedText = event.clipboardData.getData('text');
        const numbers = pastedText.replace(/\D/g, '').slice(0, inputsLength).split('');

        if (numbers.length === inputsLength) {
            setDigits(numbers);
            const code = numbers.join('');
            onSubmit(code);
        }
    };

    return (
        <div className='flex justify-center' dir='ltr'>
            {digits.map((_, index) => (
                <DigitInput
                    key={index}
                    value={digits[index]}
                    onChange={(value) => handleInputChange(index, value)}
                    onDelete={() => handleDelete(index)}
                    inputProps={{
                        id: `digit-${index}`,
                        onPaste: (event) => {
                            handlePaste(event);
                        }
                    }}
                />
            ))}
        </div>
    );
};
